import { render, staticRenderFns } from "./kyc-certification-list.vue?vue&type=template&id=39d141dd&scoped=true&"
import script from "./kyc-certification-list.vue?vue&type=script&lang=js&"
export * from "./kyc-certification-list.vue?vue&type=script&lang=js&"
import style0 from "./kyc-certification-list.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./kyc-certification-list.vue?vue&type=style&index=1&id=39d141dd&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "39d141dd",
  null
  
)

export default component.exports